function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.5 5.5C13.5 5.77614 13.7239 6 14 6C14.2761 6 14.5 5.77614 14.5 5.5H13.5ZM14.5 14.5C14.5 14.2239 14.2761 14 14 14C13.7239 14 13.5 14.2239 13.5 14.5H14.5ZM6 3.5H12V2.5H6V3.5ZM12 16.5H6V17.5H12V16.5ZM4.5 15V5H3.5V15H4.5ZM13.5 5V5.5H14.5V5H13.5ZM14.5 15V14.5H13.5V15H14.5ZM6 16.5C5.17157 16.5 4.5 15.8284 4.5 15H3.5C3.5 16.3807 4.61929 17.5 6 17.5V16.5ZM12 17.5C13.3807 17.5 14.5 16.3807 14.5 15H13.5C13.5 15.8284 12.8284 16.5 12 16.5V17.5ZM12 3.5C12.8284 3.5 13.5 4.17157 13.5 5H14.5C14.5 3.61929 13.3807 2.5 12 2.5V3.5ZM6 2.5C4.61929 2.5 3.5 3.61929 3.5 5H4.5C4.5 4.17157 5.17157 3.5 6 3.5V2.5Z",
  fill: "black"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M16 7L19 10L16 13",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M10 10H19",
  stroke: "black",
  strokeLinecap: "round"
});

var SvgSignOut = function SvgSignOut(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSignOut, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sign-out.a59eec3e.svg";
export { ForwardRef as ReactComponent };